import { parsePathname, isTrustedUrl } from './url'

export default (centreSlug, entry, opts = { supportsAbsolute: false }) => {
  // Refactor is required so that entries are always passed in with a consistent
  // 'type' field whether they come from Happenings, Modules etc.
  const entryType = (entry.sys.contentTypeId || entry.__typename).toLowerCase()
  if (entryType === 'featuredlink') {
    // TODO this is a workaround fallback in case a featured link is put in a
    // display mode that doesn't support it (currently any except spotlight)
    // It only works if the featured link URL points to this website, otherwise
    // it's going to 404, so it should definitely be set on fire at some point

    // N.B. in some cases, we want to be able to change to a trusted subdomain,
    // e.g. direct.westfield.com.au
    if (opts.supportsAbsolute) {
      return isTrustedUrl(entry.url)
    } else {
      return parsePathname(entry.url)
    }
  } else if (entryType === 'topic') {
    return `/${centreSlug}/${entry.slug}`
  } else {
    return `${`/${centreSlug}/${entryType}/${entry.sys.id}/${entry.slug}`}`
  }
}
